import merge from "deepmerge";
import { DC_SITE_CODE } from "../constants/site";

const OAUTH_CLIENT_ID = "nike.gfls.node-ext-pallet-group-svc";
const DEFAULT_OIDC_SCOPES = ["openid", "profile", "email"];
const DEFAULT_PALLET_GROUP_API_SCOPES = [
  "node_management:node.ext.pallet.group::read:",
  "node_management:node.ext.pallet.group::create:",
  "node_management:node.ext.pallet.group::update:",
];

function buildOAuthScopes() {
  const custom = process.env.REACT_APP_OAUTH_SCOPES?.trim();
  if (custom) {
    return [...DEFAULT_OIDC_SCOPES, custom];
  }
  return [...DEFAULT_OIDC_SCOPES, ...DEFAULT_PALLET_GROUP_API_SCOPES];
}

function buildOAuthConfig() {
  const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID || OAUTH_CLIENT_ID;

  return {
    clientId,
    redirectUri: window.location.origin,
    userInfo:
      "https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/userinfo",
    scopes: buildOAuthScopes(),
  };
}

const base = {
      appFullName: "Node Extension Pallet Group",
      appName: "NodeExtPalletGroup",
      description: "Node Extension Pallet Group UI for DECON flow",
      flowType: "DECON",
      dcSite: DC_SITE_CODE,
      isProd: false,
      oAuth: buildOAuthConfig(),
    },
    dev = merge(base, {
      palletGroupApi:
          process.env.REACT_APP_PALLET_GROUP_API ||
          "https://node-awm-extn-pallet-group-svc-dev-eu.nodemanagement-test.nikecloud.com",
      splunkEnv: "dev",
      splunkGeo: "sec",
    }),
    prod = merge(base, {
      palletGroupApi:
          "https://node-awm-extn-pallet-group-svc-prod-eu.nodemanagement-prod.nikecloud.com",
      isProd: true,
      splunkEnv: "prod",
      splunkGeo: "sec",
    }),
    test = merge(base, {
      palletGroupApi:
          "https://node-awm-extn-pallet-group-svc-test-eu.nodemanagement-test.nikecloud.com",
      splunkEnv: "test",
      splunkGeo: "sec",
    }),
    test_sec = merge(base, {
        palletGroupApi:
            "https://node-awm-extn-pallet-group-svc-test-sec-eu.nodemanagement-test.nikecloud.com",
        splunkEnv: "test",
        splunkGeo: "sec",
    }),
    vpt = merge(base, {
      palletGroupApi:
          "https://node-awm-extn-pallet-group-svc-vpt-eu.nodemanagement-test.nikecloud.com",
      splunkEnv: "test",
      splunkGeo: "sec",
    }),
    stage = merge(base, {
      palletGroupApi:
          "https://node-awm-extn-pallet-group-svc-stage-eu.nodemanagement-test.nikecloud.com",
      splunkEnv: "test",
      splunkGeo: "sec",
    });

function isLocalDevHostname(hostname) {
  if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]") {
    return true;
  }
  // CRA "On Your Network" URL (e.g. 192.168.x.x) should still hit local bootRun.
  return (
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)
  );
}

let env = dev;
if (isLocalDevHostname(window.location.hostname)) {
  env = merge(dev, {
    palletGroupApi:
        process.env.REACT_APP_PALLET_GROUP_API || "http://localhost:8080",
  });
} else if (
    window.location.origin.includes("node-extn-pallet-group-prod.nike.com") ||
    window.location.origin.includes("node-extn-pallet-group-ui-prod.nike.com")
) {
  env = prod;
} else if (
    window.location.origin.includes("node-extn-pallet-group-dev.nike.com") ||
    window.location.origin.includes("node-extn-pallet-group-ui-dev.nike.com")
) {
  env = dev;
} else if (
    window.location.origin.includes("node-extn-pallet-group-test.nike.com") ||
    window.location.origin.includes("node-extn-pallet-group-ui-test.nike.com")
) {
  env = test;
} else if (
    window.location.origin.includes("node-extn-pallet-group-test-sec.nike.com") ||
    window.location.origin.includes("node-extn-pallet-group-ui-test-sec.nike.com")
) {
    env = test_sec;
} else if (
    window.location.origin.includes("node-extn-pallet-group-stage.nike.com") ||
    window.location.origin.includes("node-extn-pallet-group-ui-stage.nike.com")
) {
  env = stage;
} else if (
    window.location.origin.includes("node-extn-pallet-group-vpt.nike.com") ||
    window.location.origin.includes("node-extn-pallet-group-ui-vpt.nike.com")
) {
  env = vpt;
}

const config = merge(env, { oAuth: buildOAuthConfig() });
export default config;
